import React from "react";
import { cn } from "./utils";

const TONE_CLASS = {
  neutral: "border-slate-300 bg-slate-100 text-slate-700",
  info: "border-sky-300 bg-sky-100 text-sky-800",
  success: "border-emerald-300 bg-emerald-100 text-emerald-800",
  warning: "border-amber-300 bg-amber-100 text-amber-800",
  danger: "border-rose-300 bg-rose-100 text-rose-800",
};

const STATUS_TONE_MAP = {
  concept: "neutral",
  nieuw: "neutral",
  gereed_voor_planning: "warning",
  gepland: "info",
  in_uitvoering: "info",
  tijdelijk_stilgelegd: "danger",
  on_hold: "warning",
  afgerond: "success",
  gesloten: "neutral",
  actief: "success",
  done: "success",
  failed: "danger",
  blocked: "danger",
  pending: "warning",
};

export default function StatusBadge({ children, label, status = "", tone = "", className = "" }) {
  const normalized = String(status || "").trim().toLowerCase();
  const resolvedTone = tone || STATUS_TONE_MAP[normalized] || "neutral";
  const text = children || label || status || "-";

  return (
    <span
      className={cn(
        "inline-flex items-center rounded-sm border px-2 py-0.5 text-xs font-medium",
        TONE_CLASS[resolvedTone] || TONE_CLASS.neutral,
        className
      )}
    >
      {text}
    </span>
  );
}
